var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessView)?_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"slide-x-transition","nudge-width":200,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","dark":"","icon":""}},on),[_c('v-icon',[_vm._v("today")])],1)]}}],null,false,4216167020),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),(_vm.menu)?_c('calendario-card'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/custom/abbrasil/spa/calendario/CalendarioToolbar.vue?vue&type=template&id=4f841afb&
// module id = 1100
// module chunks = 28